import React from "react";
import Peixe from "../../../imgs/CidadeAveiro/peixe.jpg";
import Centro from "../../../imgs/CidadeAveiro/centro.jpg";
import Praia from "../../../imgs/CidadeAveiro/praia.jpg";
import Salinas from "../../../imgs/CidadeAveiro/salinas.jpg";
import { withNamespaces } from 'react-i18next';

const ImgCarousel = ({t}) => {
  return (
    <>
      <div
        id="bControl"
        className="carousel slide"
        data-bs-ride="carousel"
      >
        <div className="carousel-inner">
          <div className="carousel-item active">
            <img className="d-block w-100" src={Peixe} alt={t('moduleCidadeAveiro:S1.C.Alt1')}  />
          </div>
          <div className="carousel-item">
            <img className="d-block w-100" src={Centro} alt={t('moduleCidadeAveiro:S1.C.Alt2')} />
          </div>
          <div className="carousel-item">
            <img className="d-block w-100" src={Praia} alt={t('moduleCidadeAveiro:S1.C.Alt3')}/>
          </div>
          <div className="carousel-item">
            <img className="d-block w-100" src={Salinas} alt={t('moduleCidadeAveiro:S1.C.Alt4')}/>
          </div>
        </div>
        <a
          className="carousel-control-prev"
          href="#bControl"
          role="button"
          data-bs-slide="prev"
        >
          <span
            className="carousel-control-prev-icon"
            aria-hidden="true"
          ></span>
          <span className="visually-hidden">{t('moduleCidadeAveiro:S1.C.P1')}</span>
        </a>
        <a
          className="carousel-control-next"
          href="#bControl"
          role="button"
          data-bs-slide="next"
        >
          <span
            className="carousel-control-next-icon"
            aria-hidden="true"
          ></span>
          <span className="visually-hidden">{t('moduleCidadeAveiro:S1.C.P2')}</span>
        </a>
      </div>
    </>
  );
};

export default withNamespaces() (ImgCarousel);